import { render, staticRenderFns } from "./EditorElementInfoProperties.vue?vue&type=template&id=2cb0a2bb&lang=pug"
import script from "./EditorElementInfoProperties.vue?vue&type=script&lang=js"
export * from "./EditorElementInfoProperties.vue?vue&type=script&lang=js"
import style0 from "./EditorElementInfoProperties.vue?vue&type=style&index=0&id=2cb0a2bb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports